import { isEmpty } from 'lodash-es'

import { pricingService } from '../../service/pricing-service'
import { tap } from 'rxjs/operators'

export const namespace = 'PRICING'

export const types = {
  GET_PRICINGS: 'getPricingList',
  SET_PRICINGS: 'setPricingList',
  SET_REGION: 'setRegionCode',
  SET_SELECTED_SERVICE: 'setSelectedService'
}

const state = {
  pricingList: [],
  selectedRegion: 'KR1',
  selectedCategoryName: 'Compute',
  selectedServiceName: 'Instance',
  regionCodeList: [],
  contents: []
}

const mutations = {
  [types.SET_PRICINGS](state, payload) {
    state.pricingList = payload
  },
  [types.SET_REGION](state, region) {
    state.selectedRegion = region
  },
  setCategoryName(state, categoryName) {
    state.selectedCategoryName = categoryName
  },
  setServiceName(state, serviceName) {
    state.selectedServiceName = serviceName
  },
  setRegionCodeList(state, regionCodeList) {
    state.regionCodeList = regionCodeList
  },
  setContents(state, contents) {
    state.contents = contents
  }
}

const actions = {
  [types.GET_PRICINGS]({ state, commit }, country) {
    if (isEmpty(state.pricingList) == false) {
      return
    }

    return pricingService
      .getPricingList$(country)
      .pipe(tap(pricingList => commit(types.SET_PRICINGS, pricingList)))
      .toPromise()
  },
  [types.SET_SELECTED_SERVICE]({ commit }, payload) {
    if (isEmpty(payload.regionCodeList) == false) {
      commit('setRegionCodeList', payload.regionCodeList)
    }
    if (isEmpty(payload.contents) == false) {
      commit('setContents', payload.contents)
    }
    commit('setCategoryName', payload.categoryName)
    commit('setServiceName', payload.serviceName)
  },
  [types.SET_REGION]({ commit }, region) {
    commit(types.SET_REGION, region)
  }
}

export const pricingStore = {
  state,
  mutations,
  actions,
  namespace,
  types
}
